import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

export const validation = yupResolver(
  yup.object({
    name: yup.string().required("Name is required.").max(256, "Name must be under 256 characters."),
    resourcetype: yup
      .object({ label: yup.string(), value: yup.string() })
      .nullable()
      .required("Template is required."),
  })
);
